module.exports = __webpack_public_path__ + "static/media/lobby.26308c04.jpg";